import { Api } from '../AApi'

export const API_RASTER_TYPE = new Api({ url: 'raster-types' })
